export interface SceneFormats {
  Ply: number;
  Splat: number;
  KSplat: number;
  Spz: number;
}

const extensionFormats: ReadonlyArray<[string, keyof SceneFormats]> = [
  [".ply", "Ply"],
  [".splat", "Splat"],
  [".ksplat", "KSplat"],
  [".spz", "Spz"],
];

function withoutQueryOrFragment(value: string): string {
  return value.split(/[?#]/, 1)[0]!.toLowerCase();
}

export function inferSceneFormat(sourceUrl: string, sourceName: string, formats: SceneFormats): number | undefined {
  for (const candidate of [sourceName, sourceUrl]) {
    const path = withoutQueryOrFragment(candidate);
    const match = extensionFormats.find(([extension]) => path.endsWith(extension));
    if (match) return formats[match[1]];
  }
  return undefined;
}
